import styled from 'styled-components';

export const Container = styled.div``;

export const PreviewData = styled.div`
  grid-area: prevAbastecimento;
  background: #94f7ff36;
  border: 1px solid #0b29fb;
  border-left: 4px solid #0b29fb;
  border-radius: 8px;
  padding: 16px 19px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 114px;

  @media (max-width: 768px) {
    flex-direction: column;
    max-height: unset;
    align-items: flex-start;
  }
`;

export const BaseWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const BaseLabel = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: #000fff;
  display: inline-block;
  font-family: 'Mangueira Bold';
`;

export const BaseData = styled.span`
  display: inline-block;
`;

export const PreviewWrap = styled.div`
  width: 75%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const TitleWrap = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
  }
`;

export const TitleIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #3d3d3d;
  display: inline-block;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const Info = styled.span`
  font-family: 'Mangueira Bold', sans-serif;
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #000fff;
  line-height: 21px;

  @media (max-width: 768px) {
    margin-top: 12px;
  }
`;

export const IconContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
`;

export const DescriptionWrap = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const DescriptionInfo = styled.span`
  display: inline-flex;
  font-size: 18px;
  font-weight: 400;
  color: #000;
  line-height: 21px;
  margin-top: 8px;
`;

export const Divider = styled.div`
  height: 55px;
  width: 2px;
  margin: 0 16px;
  border-left: 2px dashed #cccccc;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const PreviewTitleWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    align-items: flex-start;
    gap: 12px;
  }

  > svg {
    color: #ead414;
    min-height: 25px;
    min-width: 25px;

    @media (max-width: 768px) {
      display: none;
    }
  }
`;
